import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="pt-2 mt-2 text-muted"
      style={{
        maxWidth: '1200px',
        margin: '0 auto',
        backgroundColor: '#fff',
        fontSize: '0.9rem',
        lineHeight: '1.8',
        padding: '0px 5px 70px'
      }}
    >
      <div className="container footer-wrapper">
        <div className="ptg__footer__company__container">
          <div className="ptg__footer__company__wrapper">
            <div className="ptg__footer__company__wrapper centered">
              <span className="ptg__footer__company-info">
                <Link to="/join/agreement">이용약관</Link> |{' '}
                <Link to="/join/jungbo">개인정보처리방침</Link>
              </span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info"><strong>우에우에테낭고</strong></span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info" style={{ whiteSpace: 'nowrap' }}>전북특별자치도 완주군 소양면 잠평1길 70</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">대표번호 : 010-2652-9981</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">대표 : 임승철</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">개인정보보호책임자 : 임승철</span>
              <span className="division"> </span>
              <br />
              <span className="ptg__footer__company-info">사업자등록번호 : 792-47-00249</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">통신판매업신고 : 제2026-전북완주-0079호</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">
                <a href="mailto:haza0503@naver.com">huehuetenango@naver.com</a>
              </span>
            </div>

            <div className="mt-2">
              <span className="ptg__footer__company-info">
                &copy; 2026 NERINE, Inc. All Rights Reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
